<template>
  <div class="server-group-container">
    <el-table :data="backendServerListData" class="backend-server-list"
              v-loading="listenerRefreshLoading"
              max-height='450'>
      <!--资源类型-->
      <el-table-column :label="$t('slb.serverGroup.sourceType')" min-width="145">
        <template slot-scope="scope">
          {{ $t('slb.serverGroup.cps') }}
        </template>
      </el-table-column>
      <!--实例名称-->
      <el-table-column :label="$t('slb.serverGroup.instanceName')" min-width="120">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.name" placement="bottom">
            <span>{{scope.row.name | maybeEmpty}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--实例ID-->
      <el-table-column :label="$t('slb.serverGroup.instanceId')"
                       prop="instanceId" min-width="220">
        <template slot-scope="scope">
          <el-tooltip class="item" effect="dark" :content="scope.row.instanceId"
                      placement="bottom">
            <span>{{scope.row.instanceId| maybeEmpty}}</span>
          </el-tooltip>
        </template>
      </el-table-column>
      <!--可用区-->
      <el-table-column :label="$t('slb.serverGroup.region')" min-width="120" prop="az" key="az">
        <template slot-scope="scope">
          {{scope.row.azName | maybeEmpty}}
        </template>
      </el-table-column>
      <!--目标内网IP地址-->
      <el-table-column :label="$t('eip.text.ipAddress')"
        prop="selectedIpAddress"
        min-width="130">
        <template slot-scope="scope">
          <p v-if="scope.row.iptype === '0'">{{`${scope.row.rip}(${$t('privateNetInstance.intranetIp')})`}}</p>
          <p v-else>
            {{`${scope.row.aliasip}(${$t('subnet.text.ipAlias')})`}}
          </p>
        </template>
      </el-table-column>
      <!--端口-->
      <el-table-column :label="$t('slb.serverGroup.port')" prop="port" min-width="50">
        <template slot-scope="scope">
          {{scope.row.port | maybeEmpty}}
        </template>
      </el-table-column>
      <!--权重-->
      <el-table-column :label="$t('slb.serverGroup.weights')" min-width="65" prop="weight">
        <template slot-scope="scope">
          {{scope.row.weight | maybeEmpty}}
        </template>
      </el-table-column>
      <!--状态-->
      <el-table-column :label="$t('slb.serverGroup.status')" prop="statusName" key="statusName"
                       min-width="60" :show-overflow-tooltip="true">
        <template slot-scope="scope">
          {{InstanceStatusMapConstant[scope.row.status] | maybeEmpty}}
        </template>
      </el-table-column>
      <!--健康状态-->
      <el-table-column :label="$t('slb.text.healthyStatus')" prop="healthyStatus" key="healthyStatus"
                       min-width="100" v-if="type === 'detail'">
        <template slot-scope="scope">
          {{scope.row.healthyStatus ? BackendServerConstant[scope.row.healthyStatus.toUpperCase()]
          : '--'}}
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
  import { InstanceStatusMapConstant, BackendServerConstant } from '@/common/Constants'

  export default {
    props: {
      // 服务器组ID
      serverGroupId: {
        type: String,
        default: '',
      },
      // 地域
      region: {
        type: String,
        default: '',
      },
      // 创建监听器还是监听器详情（前者没有健康状态最后一列，后者有）
      type: {
        type: String,
        default: '',
      },
      listenerId: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
        backendServerListData: [],
        listenerRefreshLoading: false
      }
    },
    computed: {
      InstanceStatusMapConstant : () =>{
        return InstanceStatusMapConstant
      },
      BackendServerConstant : () => {
        return BackendServerConstant
      }
    },
    watch: {
      serverGroupId(val) {
        if (val !== '') {
          if (this.region !== '') {
            this.getServerList();
          }
        }
      }
    },
    methods: {
      // 获取服务器组下服务器列表
      getServerList() {
        this.listenerRefreshLoading = true;
        const params = {
          region: this.region,
          pageNumber: 1,
          pageSize: 200,
          serverGroupId: this.serverGroupId
        }
        if(this.listenerId !== ''){
          params.listenerId = this.listenerId
        }
        Ajax.get('/api/cps/serverGroups/listServers', params)
          .then((res) => {
            this.backendServerListData = res.data.servers;
          })
          .catch(async (err) => {
            const {response} = err.data;
            try {
              const json = await response.json();
              this.$message.error(json.errmsg);
            } catch (ex) {
              console.log(ex);
            }
          })
          .finally(() => {
            this.listenerRefreshLoading = false;
          });
      },
    },
    mounted() {
    }
  };
</script>

<style lang="scss">
  @import '~@/assets/scss/listComon';
</style>



// WEBPACK FOOTER //
// src/components/slb/detail/ServerGroup.vue